import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-conditionsof-use',
  templateUrl: './conditionsof-use.component.html',
  styleUrls: ['./conditionsof-use.component.scss']
})
export class ConditionsofUseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
